(function(){
  var el=document.getElementById('slTimer'); if(!el) return;
  var key='sl_timer_start_v1';
  var dur=48*60*60*1000;
  var start=sessionStorage.getItem(key);
  if(!start){start=String(Date.now());sessionStorage.setItem(key,start);}
  start=parseInt(start,10);
  if(isNaN(start)||Date.now()-start>=dur){start=Date.now();sessionStorage.setItem(key,String(start));}
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var rem=dur-(Date.now()-start); if(rem<0)rem=0;
    var h=Math.floor(rem/3600000), m=Math.floor((rem%3600000)/60000), s=Math.floor((rem%60000)/1000);
    var H=document.getElementById('slH'),M=document.getElementById('slM'),S=document.getElementById('slS');
    if(H)H.textContent=pad(h); if(M)M.textContent=pad(m); if(S)S.textContent=pad(s);
  }
  tick(); setInterval(tick,1000);
})();